var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prediction-details"},[_vm._v("\n  זה הסכום שהמערכת צופה ש"+_vm._s(_vm.actionText)+" ב\""+_vm._s(_vm.predictedTransaction.name)+"\" ב"+_vm._s(_vm.predictionTimePeriod)+" החודש\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5201af28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/PredictionDetails.vue
// module id = null
// module chunks = 